import type { Stock, StockPrice } from "@/types/stock"
import client from "./client"

export async function getStocks(): Promise<Stock[]> {
  const { data } = await client.get<Stock[]>("/api/stocks")
  return data
}

export async function getStock(code: string): Promise<Stock> {
  const { data } = await client.get<Stock>(`/api/stocks/${code}`)
  return data
}

export async function getStockPrices(code: string, from: string, to: string): Promise<StockPrice[]> {
  const { data } = await client.get<StockPrice[]>(`/api/stocks/${code}/prices`, {
    params: { from, to },
  })
  return data
}
